export default {
  // Text Panel
  '文本': 'テキスト',
  '颜色': '色',
  '字体': 'フォント',
  '大写': '大文字',
  '字号': 'フォントサイズ',
  '背景色': '背景色',
  '圆角': '角の丸み',
  '内边距': 'パディング',
  '描边': 'ストローク',
  '对齐': '配置',
  '底边距': '下部マージン',
  '紧贴底边': '下部配置',
  '垂直居中': '垂直中央',

  // Basic Panel
  '基础': '基本',
  '位置': '位置',
  '尺寸': 'サイズ',
  '旋转': '回転',
  '居中': '中央',
  '原始尺寸': '元のサイズ',
  '平铺': 'タイル',
  '拉伸': 'ストレッチ',
  '透明度': '不透明度',
  '视频尺寸为{width}x{height}。': 'ビデオサイズは{width}x{height}です。',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': 'テキストサイズを調整すると表示が変わる場合があります。フォントサイズを調整することを推奨します',

  // Library
  '视频': '動画',
  '音频': '音声',
  '图片': '画像',
  '新建文本': '新しいテキスト',
  '花字库': 'フォントライブラリ',
  '默认文本': 'デフォルトテキスト',

  // Export
  '导出': 'エクスポート',

  // Tools
  '撤销': '元に戻す',
  '重做': 'やり直す',

  // Tooltips
  '清除选中': '選択をクリア',
  '删除当前选中': '選択を削除',
  '分割当前选中': '選択を分割',
  '分割当前选中，只保留左侧': '選択を分割し、左側のみを保持',
  '分割当前选中，只保留右侧': '選択を分割し、右側のみを保持',
  '水平翻转': '水平反転',
  '将连续且相邻的素材拼接后下载': '連続して並んでいる素材を連結してダウンロード',

  // Library
  '当前': '現在',
  '导入': 'インポート',
  '全部': 'すべて',
  '删除': '削除',
  '拖拽视频到这里': 'ここに動画をドラッグ',
  '拖拽音频到这里': 'ここに音声をドラッグ',
  '拖拽图片到这里': 'ここに画像をドラッグ',
  '或者点击上传': 'またはクリックしてアップロード',
  '暂无素材，请先导入素材': '素材がありません。まず素材をインポートしてください',

  // Manager
  '选择一个视频，开始你的创作。': '動画を選択して、作成を開始してください。',

  // Animation Panel
  '动画': 'アニメーション',
  '入场动画': 'エンターアニメーション',
  '出场动画': 'エグジットアニメーション',
  '关键帧动画': 'キーフレームアニメーション',
  '选择动画效果': 'アニメーション効果を選択',
  '添加': '追加',
  '确定删除此动画？': 'このアニメーションを削除してもよろしいですか？',
  '持续时间': '期間',
  '秒': '秒',
  '起始时间': '開始時間',
  '结束时间': '終了時間',
  '暂无动画，请添加动画效果': 'アニメーションがありません、アニメーション効果を追加してください',

  // Animation Presets
  '淡入': 'フェードイン',
  '从左滑入': '左からスライドイン',
  '从右滑入': '右からスライドイン',
  '从上滑入': '上からスライドイン',
  '从下滑入': '下からスライドイン',
  '放大进入': 'ズームイン',
  '旋转进入': '回転して入る',
  '淡出': 'フェードアウト',
  '向左滑出': '左にスライドアウト',
  '向右滑出': '右にスライドアウト',
  '向上滑出': '上にスライドアウト',
  '向下滑出': '下にスライドアウト',
  '缩小退出': 'ズームアウト',
  '旋转退出': '回転して出る',
  '脉冲': 'パルス',
  '抖动': 'シェイク',
  '弹跳': 'バウンス',
  '摆动': 'スウィング',
  '闪烁': 'フラッシュ',
  '自定义': 'カスタム',
  '起始状态': '開始状態',
  '结束状态': '終了状態',
  '位置 X': '位置 X',
  '位置 Y': '位置 Y',
  '缩放': 'スケール',
  '旋转角度': '回転角度',
  '不透明度': '不透明度',

  // Filter Panel
  '可用滤镜': '使用可能なフィルター',
  '滤镜参数': 'フィルターパラメータ',
  '选择滤镜': 'フィルターを選択',
  '请选择要编辑的滤镜': '編集するフィルターを選択してください',
  '强度': '強度',
  '请选择一个滤镜以调节参数': 'パラメータを調整するにはフィルターを選択してください',
  '灰度': 'グレースケール',
  '模糊': 'ぼかし',
  '亮度': '明るさ',
  '对比度': 'コントラスト',
  '饱和度': '彩度',

  '无': 'なし',
  '入场': '入場',
  '出场': '出場',
  '动效': 'アニメーション',
  '结束位置': '終了位置',
  '使用当前时间轴上的当前时间点': 'タイムライン上の現在の時間点を使用',
  '开始位置': '開始位置',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': '現在のアニメーションでは直接的な効果が表示されない場合があります。セグメントを再生して確認してください',
  '滤镜': 'フィルター',
  '恢复正在编辑的数据': '編集中のデータを復元',
  '转场': 'トランジション',
  '转场效果': 'トランジション効果',
  '点击应用': 'クリックして適用',
  '仅支持视频和图片': 'ビデオと画像のみサポート',
  '删除转场': 'トランジションを削除',
  '已经存在视频转场，请先删除': 'ビデオトランジションが既に存在します。先に削除してください',
  '当前片段是轨道最后一个片段，不能应用转场效果': '現在のセグメントはトラックの最後のセグメントです。トランジション効果を適用できません',
  '暂无转场效果': 'トランジション効果がありません',
  '片段不存在': 'セグメントが存在しません',
  '请先选择一个片段': 'まずセグメントを選択してください',
  '轨道不存在': 'トラックが存在しません',
  '默认': 'デフォルト',

  // 转场效果
  '淡入淡出': 'フェード',
  '滑动': 'スライド',
  '百叶窗': 'ブラインド',
  '溶解': 'ディゾルブ',

  // Video/Audio Panel
  '音量': '音量',
  '请先选择视频片段': '最初にビデオセグメントを選択してください',
  '请先选择音频片段': '最初に音声セグメントを選択してください',
  '重置': 'リセット',

  // Advanced Export
  '高级导出': '高度なエクスポート',
  '取消': 'キャンセル',
  '正在导出...': 'エクスポート中...',
  '导出完成！': 'エクスポート完了！',
  '导出失败：': 'エクスポートに失敗：',
  '导出类型': 'エクスポートタイプ',
  '输出格式': '出力形式',
  '分辨率': '解像度',
  '帧率': 'FPS',
  '视频比特率': 'ビデオビットレート',
  '编码格式': 'コーデック',
  '包含音频': '音声を含む',
  '关闭时将导出无声音的视频': 'オフにすると音声のない動画がエクスポートされます',
  '音频比特率': 'オーディオビットレート',
  '比特率': 'ビットレート',
  '采样率': 'サンプリングレート',
  '导出中...': 'エクスポート中...',
  '开始导出': 'エクスポート開始',
};